var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19760_26998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 0H6C2.68629 0 0 2.68629 0 6V34C0 37.3137 2.68629 40 6 40H34C37.3137 40 40 37.3137 40 34V6C40 2.68629 37.3137 0 34 0Z",
    fill: "#3171ED"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_19760_26998)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5588 12.2832L23.9094 27.2371H16.7244L19.9257 21.0395H19.782C17.141 24.468 13.2005 26.7249 7.58594 27.2371V21.1253C7.58594 21.1253 11.1777 20.9132 13.2892 18.6932H7.58594V12.2833H13.9958V17.5554L14.1397 17.5548L16.759 12.2833H21.6067V17.5219L21.7505 17.5217L24.4681 12.2832H31.5588Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19760_26998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_19760_26998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3,
    height: 14.9538,
    fill: "white",
    transform: "translate(7.58594 12.2832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCms);
export default __webpack_public_path__ + "static/media/CMS.5e029fb185260201743e47cf01983671.svg";
export { ForwardRef as ReactComponent };